var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ImageReset',{on:{"onClickCropImage":_vm.onClickCropImage,"onClickRemoveImage":_vm.onClickRemoveImage}}),(false)?_c('Background',{on:{"onClickBackgroundImage":_vm.onClickBackgroundImage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }